import { Link } from 'react-router-dom';

function tagLabel(tag) {
  if (tag == null) return '';
  return typeof tag === 'string' ? tag : tag.name ?? '';
}

/** Собирает строку источника из полей задачи (без пустых частей). */
function buildTaskSourceLine({ source_name, source_number, source_author, year }) {
  const parts = [];
  if (source_name?.trim()) parts.push(source_name.trim());
  if (source_number?.trim()) {
    const n = source_number.trim();
    parts.push(parts.length ? `№${n}` : n);
  }
  if (source_author?.trim()) parts.push(source_author.trim());
  if (year != null && year !== '') parts.push(String(year));
  return parts.join(' · ');
}

/**
 * Компактные метаданные над условием: теги, источник, опционально счётчик и ссылка на обсуждение.
 */
export default function TaskStatementMeta({
  tags = [],
  source_name,
  source_number,
  source_author,
  year,
  solutionsAcceptedCount,
  discussionTo,
  discussionUrl,
  className = '',
}) {
  const tagItems = (Array.isArray(tags) ? tags : [])
    .map(tagLabel)
    .filter((s) => s.length > 0);
  const sourceLine = buildTaskSourceLine({ source_name, source_number, source_author, year });

  const showSolutions = solutionsAcceptedCount != null;
  const showDiscussion = Boolean(discussionTo || discussionUrl);

  return (
    <div className={`task-statement-meta ${className}`.trim()}>
      <div className="task-statement-meta-row task-statement-meta-tags">
        <span className="task-statement-meta-label">Теги:</span>{' '}
        {tagItems.length > 0 ? (
          tagItems.map((name, i) => (
            <span key={i} className="task-meta-tag">
              {name}
            </span>
          ))
        ) : (
          <span className="task-statement-meta-empty">—</span>
        )}
      </div>
      <div className="task-statement-meta-row task-statement-meta-source">
        <span className="task-statement-meta-label">Источник:</span>{' '}
        <span className={sourceLine ? 'task-statement-meta-source-text' : 'task-statement-meta-empty'}>
          {sourceLine || 'не указан'}
        </span>
      </div>
      {showSolutions && (
        <div className="task-statement-meta-row task-statement-meta-extra">
          Успешных решений (всего): {solutionsAcceptedCount}
        </div>
      )}
      {showDiscussion && (
        <div className="task-statement-meta-row task-statement-meta-extra">
          {discussionTo ? (
            <Link to={discussionTo} className="task-statement-meta-link">
              Обсуждение
            </Link>
          ) : (
            <a
              href={discussionUrl}
              className="task-statement-meta-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Обсуждение
            </a>
          )}
        </div>
      )}
    </div>
  );
}
